var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.583C5.6 4.583 0 7.393 0 10.854c0 2.81 3.675 5.18 8.75 5.983v2.534c0 .564.675.84 1.063.439l3.487-3.5c.25-.25.25-.64 0-.89l-3.488-3.5a.624.624 0 0 0-1.062.452v1.906c-3.938-.702-6.25-2.383-6.25-3.424 0-1.33 3.8-3.762 10-3.762s10 2.433 10 3.762c0 .828-1.5 2.107-4.15 2.935-.513.163-.85.64-.85 1.18 0 .84.813 1.454 1.6 1.203 3.537-1.104 5.9-3.073 5.9-5.318 0-3.461-5.6-6.271-12.5-6.271z",
    fill: "#FF7D0E"
  })));
};
export default __webpack_public_path__ + "static/media/icon-roundtrip.b30e9cc1.svg";
export { SvgComponent as ReactComponent };